export function WhatsAppButton() {
  const whatsappUrl = "https://wa.me/5524993144981?text=Vim%20do%20site%20gostaria%20de%20saber%20sobre%20os%20servi%C3%A7os";

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 flex items-center justify-center p-4 rounded-full bg-brand-accent text-brand-light shadow-2xl transition duration-300 hover:bg-brand-light hover:text-brand-accent border-2 border-brand-accent hover:scale-110 active:scale-95 cursor-pointer"
      aria-label="Fale conosco no WhatsApp"
    >
      <svg
        className="w-6 h-6 fill-current"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
        <path d="M12.001 2C6.478 2 2 6.477 2 12c0 1.887.525 3.65 1.436 5.153L2 22l4.964-1.406A9.953 9.953 0 0012.001 22c5.523 0 10-4.477 10-10S17.524 2 12.001 2zm0 18.001c-1.7 0-3.36-.457-4.808-1.32l-.345-.204-3.038.86.828-3.045-.222-.313A7.965 7.965 0 014 12c0-4.411 3.589-8 8.001-8 4.411 0 8 3.589 8 8s-3.589 8.001-8 8.001z" />
      </svg>
    </a>
  );
}
